/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Создаёт для каждого набора вкладок представление обрабатывающее набор.
   */
  app.TabsListView = app.View.extend({
    el: '.sl-tabs',

    initialize: function () {
      var that = this;
      this.$el.each(function () {
        var viewModelName = $(this).data('view'); // представление отвечающее за отображение вкладки
        viewModelName = viewModelName ? viewModelName : 'TabsBaseItemView';
        new app[viewModelName]({
          el: $(this),
          model: that.model || '',
        });
      });
    }
  });
})(jQuery);

}.call(window));